import { useEffect, useRef } from 'react';

export const useObserver = ({ onIntersecting, root = null, rootMargin = '0px', threshold = 0 }) => {
  const targetRef = useRef(null);
  const observerRef = useRef(null);
  const onIntersectingRef = useRef(onIntersecting);

  useEffect(() => {
    onIntersectingRef.current = onIntersecting;
  }, [onIntersecting]);

  useEffect(() => {
    if (!targetRef.current) return;

    observerRef.current?.disconnect();

    observerRef.current = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          onIntersectingRef.current?.(entry);
        }
      },
      {
        root,
        rootMargin,
        threshold,
      },
    );

    observerRef.current.observe(targetRef.current);

    return () => {
      observerRef.current?.disconnect();
      observerRef.current = null;
    };
  }, [root, rootMargin, threshold]);

  return targetRef;
};
